import React, { Component } from "react";
import { TextField } from '@material-ui/core';

class InputTelefone extends Component {

    

    maskTelefone = value => {
        if (!value) {
            return null;
        }
        return value
            .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
            .replace(/(\d{5})(\d{4})$/, '$1-$2') // captura se o telefone de 9 digitos, e formata para 99999-9999
            .replace(/(\d{4})(\d{,4})$/, '$1-$2') // captura se o telefone tem até 8 digitos, e formata para 9999-9999
            .replace(/^(\d{2})(\d)/, '($1) $2'); // captura DDD
    }
    
    handleTelefone = async e => {
        e.target.value = this.maskTelefone(e.target.value);
        this.props.onChange(e);
    }

    render() {
        return (
            <TextField
                minLength="10"
                variant={this.props.variant} 
                margin={this.props.margin} 
                fullWidth={this.props.fullWidth} 
                required={this.props.required} 
                label={this.props.label} 
                name={this.props.name}
                disabled={this.props.disabled}
                className={`MuiOutlinedInput-root ${this.props.className}`}
                autoComplete="telefone"
                autoFocus
                onChange={this.handleTelefone}
                error={this.props.error}
                value={this.maskTelefone(this.props.value)}
                inputProps={{ maxLength: 15 }}
            />
        )
    }
}

export default InputTelefone;